import { Routes } from '@angular/router';
import { SalesComponent } from './sales/sales.component';

export const SalesRoutingModule: Routes = [{ path: 'sales', component: SalesComponent }];
